import React from 'react';
import { st, classes } from './FullScreenModalLayoutFooter.st.css';
import { FullScreenModalLayoutFooterProps } from '../../FullScreenModalLayout.types';
import { DATA_HOOKS } from '../../FullScreenModalLayout.constants';

const FullScreenModalLayoutFooter = ({
  children,
  dataHook,
  className,
}: FullScreenModalLayoutFooterProps) => {
  return (
    <div
      data-hook={dataHook || DATA_HOOKS.fullScreenModalLayoutFooter}
      className={st(classes.root, {}, className)}
    >
      {children}
    </div>
  );
};

FullScreenModalLayoutFooter.displayName = 'FullScreenModalLayout.Footer';

export { FullScreenModalLayoutFooter };
